import { AlertCircleIcon } from "lucide-react";
import { PROBLEMAS } from "../data/content";
export function Problemas() {
  return <section className="px-5 pt-10" data-id="element-180" data-mp="6egytpbh0ku9">
      <h2 className="text-center text-2xl font-black leading-snug text-blue-950" data-id="element-181" data-mp="6de8pjlz2mfe">
        Muchas veces, nuestra cabeza limita nuestro verdadero nivel
      </h2>

      <ul className="mt-6 space-y-3" data-id="element-182" data-mp="3ssqhdhspyyn4">
        {PROBLEMAS.map(p => <li key={p} className="flex items-start gap-3 rounded-2xl border border-red-100 bg-red-50/70 p-4" data-id="element-183" data-mp="3eu8wdru7808w">
            <AlertCircleIcon size={20} className="mt-0.5 flex-shrink-0 text-red-500" data-id="element-184" data-mp="3ix5m02i5owmc" />
            <span className="text-sm leading-relaxed text-gray-800" data-id="element-185" data-mp="34xxhcu384war">{p}</span>
          </li>)}
      </ul>

      <p className="mt-8 text-center text-xl font-black text-blue-800" data-id="element-186" data-mp="134ges4tyalmv">
        Para eso se ha creado este kit 👇
      </p>
    </section>;
}